import amenitiesRu from "./propertyAmenities.ru";

/**
 * Returns the translated label for a single amenity string.
 * Falls back to the original English term for unknown keys or unsupported languages.
 *
 * Dictionary-based (vs. per-slug arrays for international listings) because
 * PropertyFinder uses a fixed, shared vocabulary across all UAE listings.
 *
 * @param {string} amenity - Original amenity string from the data file.
 * @param {string} lang    - i18next language code ("en" | "ru").
 * @returns {string}       - Translated label, or the original if not found.
 */
export function getAmenityLabel(amenity, lang) {
  if (lang === "ru") return amenitiesRu[amenity] ?? amenity;
  return amenity;
}
